import { useCallback, useState } from 'react'
import { BlockComponentFactory } from '../BlockFactory'
import { TabsBlockProps } from './block-props.types'
import Tabs from 'antd/lib/tabs'
import classes from './TabsBlock.module.less'
import { useBlockListeners } from '../BlockHooks'
import { toCSSSize } from './block-utils'

export const TabsBlock = BlockComponentFactory.createBlockComponent<TabsBlockProps>(props => {
    const {
        direction = 'horizontal',
        items = [],
        width,
        height,
        gap = 8,
        visibility = 'visible',
        children,
    } = props

    const [onChangeListener] = useBlockListeners<(activeKey: string) => void>('onChange')
    const [activeKey, setActiveKey] = useState(items[0]?.id || '')

    const hasFixedDimensions = width || height
    const tabsStyle: React.CSSProperties = {
        ...props.style,
        display: visibility === 'hidden' ? 'none' : 'flex',
        flexDirection: 'column',
        width: toCSSSize(width) || 'auto',
        height: toCSSSize(height) || 'auto',
        overflow: hasFixedDimensions ? 'hidden' : 'visible',
    }

    const childrenArray = Array.isArray(children) ? children : []

    const tabItems = items.map((item, index) => {
        const tabChildren = childrenArray[index] || null

        return {
            key: item.id,
            label: item.label,
            children: (
                <div
                    className={classes.tabContent}
                    style={{ minHeight: hasFixedDimensions ? undefined : '100px', gap: `${gap}px` }}
                >
                    {tabChildren}
                </div>
            ),
        }
    })

    const handleChange = useCallback(
        (key: string) => {
            setActiveKey(key)
            onChangeListener?.value?.(key)
        },
        [onChangeListener]
    )

    return (
        <div style={tabsStyle} className={classes.tabsBlock}>
            <Tabs
                size="small"
                activeKey={activeKey}
                onChange={handleChange}
                tabPosition={direction === 'vertical' ? 'left' : 'top'}
                items={tabItems}
            />
        </div>
    )
})
